const getSelectedVariant = (form, product) => {
  if (!form || !product) return null;
  const idField = form.querySelector('input[name="id"]');
  const submit = form.querySelector('[type="submit"]');
  if (!idField || !submit) return;

  const selectedValues = [];
  form.querySelectorAll('[product-option] input[type="radio"]:checked').forEach(option => {
    selectedValues.push({
      value: option.value,
      index: option.name
    });
  });

  const variant = product.variants.find(variant => {
    return selectedValues.every(value => {
      return variant[value.index] == value.value;
    });
  });

  if (variant) {
    idField.value = variant.id;
    submit.disabled = typeof (variant.available) !== 'undefined' ? !variant.available : false;

    if (typeof (theme.Currency) !== 'undefined' && typeof (theme.Currency.formatMoney) !== 'undefined' && typeof (theme.strings.moneyFormat) !== 'undefined') {
      const isOnSale = variant.compare_at_price > 0 && variant.compare_at_price > variant.price ? true : false;
      const savingsContainer = form.querySelector('.product-tile-quick-buy__savings');
      if (savingsContainer) {
        if (isOnSale) {
          savingsContainer.innerText = `-${Math.round(((variant.price * -100) / variant.compare_at_price) + 100)}%`;
          savingsContainer.classList.remove('hidden');
        } else {
          savingsContainer.innerText = '-0%';
          savingsContainer.classList.add('hidden');
        }
      }

      const comparePriceContainer = form.querySelector('.product-tile-quick-buy__compare-at-price');
      if (comparePriceContainer) {
        if (isOnSale) {
          comparePriceContainer.classList.remove('hidden');
          comparePriceContainer.innerText = theme.Currency.formatMoney(variant.compare_at_price, theme.strings.moneyFormat);
        } else {
          comparePriceContainer.classList.add('hidden');
        }
      }

      const priceContainer = form.querySelector('.product-tile-quick-buy__price');
      if (priceContainer) {
        priceContainer.innerText = theme.Currency.formatMoney(variant.price, theme.strings.moneyFormat);
        if (isOnSale) {
          priceContainer.classList.add('on-sale');
        } else {
          priceContainer.classList.remove('on-sale');
        }
      }
    }
  } else {
    idField.value = '';
    submit.disabled = true;
  }

  const errorlabel = form.querySelector('.product-tile-quick-buy__add-error');
  if (errorlabel) {
    errorlabel.classList.add('hidden');
  }

  return variant;
};

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductTile = (tile) => {
  if (!tile || tile.classList.contains('product-tile__container--initialized')) return;

  const productFormWrapper = tile.querySelector('.product-tile__quick-buy-wrapper');
  if (!productFormWrapper) return;
  const productForm = productFormWrapper.querySelector('.product-tile__quick-buy');
  if (!productForm) return;
  const productJsonScript = productForm.querySelector('[product-json]');
  const idField = productForm.querySelector('input[name="id"]');
  const submit = productForm.querySelector('[type="submit"]');
  if (!idField || !productJsonScript || !productJsonScript.innerHTML.trim()) return;
  var product = JSON.parse(productJsonScript.innerHTML.trim());
  var addedEvents = false;

  const addListeners = () => {
    productForm.addEventListener('change', () => {
      getSelectedVariant(productForm, product);
    });

    productForm.addEventListener('submit', e => {
      e.preventDefault();
      if (typeof (ShopifyAPI) !== 'undefined' && typeof (ShopifyAPI.addItemFromForm) !== 'undefined') {
        ShopifyAPI.addItemFromForm(
          productForm,
          () => {
            if (productFormWrapper) {
              productFormWrapper.classList.remove('open');
            }

            document.querySelector('html').style.overflow = 'visible';

            if (typeof (theme.settings.cartType) === 'undefined' || theme.settings.cartType === 'drawer') {
              if (typeof (ShopifyAPI.getCart) !== 'undefined') {
                ShopifyAPI.getCart(() => {
                  if (typeof (ajaxCart) !== 'undefined' && typeof (ajaxCart.load) !== 'undefined') {
                    ajaxCart.load();
                  }
                });
              }
            } else {
              ajaxCart.load();
            }
          },
          (XMLHttpRequest, textStatus) => {
            const errorlabel = productForm.querySelector('.product-tile-quick-buy__add-error');
            if (errorlabel) {
              errorlabel.innerText = XMLHttpRequest.responseJSON.description;
              errorlabel.classList.remove('hidden');
              setTimeout(() => {
                errorlabel.classList.add('hidden');
              }, 3000);
            }
          }
        );
      } else {
        productForm.submit();
      }
    });
  };

  productFormWrapper.addEventListener('click', (e) => {
    if (!(e.target.classList.contains('.product-tile__quick-buy') || e.target.closest('.product-tile__quick-buy'))) {
      productFormWrapper.classList.remove('open');
      document.querySelector('html').style.overflow = '';
      tile?.appendChild(productFormWrapper);
    }
  });

  const quickBuyOpener = tile.querySelector('.product-tile__quick-buy-opener');
  if (quickBuyOpener) {
    quickBuyOpener.addEventListener('click', async () => {
      if (!addedEvents) {
        if (typeof (product) === 'string') {
          await fetch(`${Shopify.routes.root}products/${product}.json`)
            .then(res => res.json()).then(data => {
              if (typeof (data.product) !== 'undefined') {
                product = data.product;
              }
            });
        }
        if (typeof (product) !== 'object') return;

        getSelectedVariant(productForm, product);
        addListeners();
        addedEvents = true;
      }
      submit.classList.remove('loading');
      if (productFormWrapper.parentNode !== document.body) {
        document.body.appendChild(productFormWrapper);
      }
      productFormWrapper.classList.add('open');
      document.querySelector('html').style.overflow = 'hidden';

      const quickBuyGallery = productFormWrapper.querySelector('.product-tile-quick-buy__gallery');
      const quickBuyImages = quickBuyGallery.querySelectorAll('.product-tile-quick-buy__image');

      [].forEach.call(quickBuyImages, (quickBuyImage) => {
        if (!quickBuyImage.classList.contains('swiper-slide')) {
          quickBuyImage.classList.add('swiper-slide');
        }
      });

      if (quickBuyGallery && quickBuyGallery.querySelectorAll('.swiper-slide').length > 1 && !quickBuyGallery.classList.contains('swiper-initialized')) {
        new Swiper(quickBuyGallery, {
          loop: true,

          pagination: {
            el: quickBuyGallery.querySelector('.product-tile-quick-buy__pagination'),
            clickable: true
          }
        });
      }
    });
  }

  const quickBuyClose = tile.querySelector('.product-tile-quick-buy__close-icon');
  if (quickBuyClose) {
    quickBuyClose.addEventListener('click', () => {
      productFormWrapper.classList.remove('open');
      document.querySelector('html').style.overflow = '';
      tile?.appendChild(productFormWrapper);
    });
  }

  tile.querySelector('a.product-tile__images-container').addEventListener('click', (e) => {
    if (e.target.closest('.product-tile__buttons')) {
      e.preventDefault();
    }
  });

  tile.classList.add('product-tile__container--initialized');
};

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.product-tile__container'), (tile) => {
    window.dAgency.initProductTile(tile);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.product-tile__container'), (tile) => {
      window.dAgency.initProductTile(tile);
    });
  });
}
